import firebase from "../../config/firebase";
import { toast } from "react-toastify";
import { setLoggingOut } from "./authLogoutFlag";

export const register = (creds, password, paypalDetail, survey) => {
  return async (dispatch) => {
    if (creds.dateOfBirth) {
      const [year, month, day] = creds.dateOfBirth.split("-").map(Number);
      const dateObject = new Date(year, month - 1, day, 0, 0, 0);
      const timestamp = firebase.firestore.Timestamp.fromDate(dateObject);
      creds.dateOfBirth = timestamp;
    }
    dispatch({
      type: "ACTION_REQUEST",
    });
    firebase
      .auth()
      .createUserWithEmailAndPassword(creds.email, password)
      .then(async (data) => {
        // Send email verification immediately after account creation
        try {
          await data.user.sendEmailVerification({
            url: window.location.origin + "/auth/login",
            handleCodeInApp: false,
          });
          toast.info("Verification email sent! Please check your inbox.");
        } catch (verificationError) {
          console.error("Error sending verification email:", verificationError);
          toast.warning("Account created, but we couldn't send the verification email. You can resend it from the verification page.");
        }

        let payObj = {
          fan_id: data.user.uid,
          payment_id: paypalDetail.id,
          created_at: firebase.firestore.Timestamp.now(),
          amount: paypalDetail.purchase_units[0].amount,
          type: "fan payments",
        };
        firebase.firestore().collection("signup_payments").add(payObj);
        if (creds.photo) {
          const storageRef = firebase.storage().ref();
          const photoRef = storageRef.child(
            `users/${data.user.uid}/manager_photo`,
          );
          const uploadTask = await photoRef.put(creds.photo);
          const photoURL = await uploadTask.ref.getDownloadURL();
          creds.photo = photoURL;
        }
        if (creds.isManager) {
          creds.managerCertified = false;
        }
        creds.veriffStatus = "not_started";
        creds.emailVerified = false; // Track in Firestore as well

        firebase
          .firestore()
          .collection("users")
          .doc(data.user.uid)
          .set(creds)
          .then((res) => {
            firebase
              .firestore()
              .collection("stats")
              .doc("survey_stats")
              .update({
                [survey]: firebase.firestore.FieldValue.increment(1),
              });
            
            // Don't call loginSuccessFull here - let the user verify email first
            dispatch({
              type: "REGISTER_SUCCESS",
              payload: { isManager: creds.isManager, needsVerification: true },
            });
            dispatch({
              type: "ACTION_REQUEST_END",
            });
            toast.success("Account Created Successfully! Please verify your email to continue. Check your spam folder if you don't see it.");
            
            // Set a temporary auth state for verification page
            dispatch({
              type: "SET_UNVERIFIED_USER",
              payload: {
                uid: data.user.uid,
                email: creds.email,
                needsVerification: true,
              },
            });
          })
          .catch((error) => {
            dispatch({
              type: "REGISTER_FAIL",
            });
            dispatch({
              type: "ACTION_REQUEST_END",
            });
            toast.warning(error.message);
          });
      })
      .catch((error) => {
        dispatch({
          type: "REGISTER_FAIL",
        });
        dispatch({
          type: "ACTION_REQUEST_END",
        });
        alert(error);
        toast.warning(error.message);
      });
  };
};
export const registerSuccess = () => {
  return (dispatch) => {
    dispatch({
      type: "REGISTER_COMPLETE",
    });
  };
};
export const login = (creds, onSuccess = () => {}) => {
  return (dispatch) => {
    dispatch({
      type: "LOGIN_REQUEST",
    });
    firebase
      .auth()
      .signInWithEmailAndPassword(creds.email, creds.password)
      .then(async (data) => {
        // Reload user to get fresh email verification status
        await data.user.reload();
        const freshUser = firebase.auth().currentUser;

        // Check if email is verified
        if (!freshUser.emailVerified) {
          dispatch({
            type: "SET_UNVERIFIED_USER",
            payload: {
              uid: freshUser.uid,
              email: freshUser.email,
              needsVerification: true,
            },
          });
          dispatch({
            type: "LOGIN_REQUEST_END",
          });
          toast.warning("Please verify your email before logging in.");
          return;
        }

        var docRef = firebase
          .firestore()
          .collection("users")
          .doc(data.user.uid);
        docRef.get().then((doc) => {
          if (doc.exists) {
            if (doc.data().blocked) {
              toast.warning("You are not allowed to access this panel");
              dispatch({
                type: "LOGIN_REQUEST_END",
              });
            } else {
              if (doc.data().role == "fan") {
                // Update emailVerified status in Firestore
                docRef.update({
                  lastLoggedIn: firebase.firestore.FieldValue.serverTimestamp(),
                  emailVerified: true,
                });
                dispatch(loginSuccessFull(data.user.uid));
                onSuccess();
              } else {
                toast.warning("You are not allowed to access this panel");
                dispatch({
                  type: "LOGIN_REQUEST_END",
                });
              }
            }
          } else {
            toast.warning("You are not allowed to access this panel");
            dispatch({
              type: "LOGIN_REQUEST_END",
            });
          }
        });
      })
      .catch((error) => {
        dispatch({
          type: "LOGIN_FAIL",
          uid: "",
          error: error,
        });
        dispatch({
          type: "LOGIN_REQUEST_END",
        });
        toast.warning(
          "Invalid credentials. Please try again with the correct information.",
        );
      });
  };
};
export const loginSuccessFull = (id) => (dispatch) => {
  firebase
    .firestore()
    .collection("users")
    .doc(id)
    .onSnapshot((doc) => {
      let userData = { id: doc.id, ...doc.data() };


      let veriffStatus = userData.veriffStatus || "not_started";
      if (userData.veriff && userData.veriff.status) {
        veriffStatus = userData.veriff.status;
      }
      userData.veriffStatus = veriffStatus;

      dispatch({
        type: "LOGIN_SUCCESS",
        user: userData,
        error: "",
      });
      dispatch({
        type: "LOGIN_REQUEST_END",
      });
    });
};
export const logout = () => {
  return (dispatch) => {
    // Signal the auth listener in App.js to skip the next callback,
    // which would otherwise race and re-set needsVerification.
    setLoggingOut();
    // Clear Redux state immediately so App.js routes away instantly.
    dispatch({ type: "LOGOUT_SUCCESS", uid: "", user: "", error: "" });
    firebase.auth().signOut().catch((error) => {
      console.error("Sign out error:", error);
    });
  };
};
export const forgetpassword = (email) => {
  return (dispatch) => {
    dispatch({
      type: "ACTION_FORGET_REQUEST",
    });
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then((res) => {
        dispatch({
          type: "ACTION_FORGET_REQUEST_END",
        });
        toast.success("Recovery Email Sent");
      })
      .catch((err) => {
        dispatch({
          type: "ACTION_FORGET_REQUEST_END",
        });
        toast.warning(err.message);
      });
  };
};
export const updatePassword = (obj, onComplete = () => {}) => {
  return (dispatch) => {
    dispatch({
      type: "PASSWORD_REQUEST",
    });
    let user = firebase.auth().currentUser;
    if (user != null) {
      let creds = firebase.auth.EmailAuthProvider.credential(
        user.email,
        obj.currentPassword,
      );
      user
        .reauthenticateWithCredential(creds)
        .then(() => {
          user.updatePassword(obj.newPassword);
          dispatch({
            type: "PASSWORD_REQUEST_END",
          });
          toast.success("Password Updated Successfully");
          onComplete("success");
        })
        .catch((error) => {
          toast.warning("Current Password is Invalid");
          dispatch({
            type: "PASSWORD_REQUEST_END",
          });
          onComplete();
        });
    } else {
      dispatch({
        type: "PASSWORD_REQUEST_END",
      });
      onComplete();
    }
  };
};

export const updatePaypalEmail = (uid, paypal_email, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      await firebase
        .firestore()
        .collection("users")
        .doc(uid)
        .update({ paypal_email });
      const doc = await firebase.firestore().collection("users").doc(uid).get();

      if (doc.exists) {
        dispatch({
          type: "LOGIN_SUCCESS",
          user: { id: doc.id, ...doc.data() },
          error: "",
        });
      }
      onSuccess();
      toast.success("PayPal email updated successfully");
    } catch (error) {
      toast.error("Failed to update PayPal email");
    }
  };
};

export const updatePaypalSecondaryEmail = (
  uid,
  secondaryPaypalEmail,
  onSuccess = () => {},
) => {
  return async (dispatch) => {
    try {
      await firebase
        .firestore()
        .collection("users")
        .doc(uid)
        .update({ secondaryPaypalEmail });
      const doc = await firebase.firestore().collection("users").doc(uid).get();

      if (doc.exists) {
        dispatch({
          type: "LOGIN_SUCCESS",
          user: { id: doc.id, ...doc.data() },
          error: "",
        });
      }
      onSuccess();
      toast.success("Secondary PayPal email updated successfully");
    } catch (error) {
      toast.error("Failed to update PayPal email");
    }
  };
};

export const isUserExist =
  (email, onComplete = () => {}) =>
  async () => {
    let user = await firebase
      .firestore()
      .collection("users")
      .where("email", "==", email)
      .get();
    if (user.docs.length == 0) {
      onComplete();
    } else {
      toast.warning("This email already exist");
    }
  };
export const checkPhoneNumber =
  (phoneNumber, onComplete = () => {}, onError = () => {}) =>
  async () => {
    try {
      // Clear any existing reCAPTCHA widget before creating a new one
      // to prevent "already rendered" errors on resend attempts
      if (window.recaptchaVerifier) {
        try {
          window.recaptchaVerifier.clear();
        } catch (_) {
          // ignore clear errors
        }
        window.recaptchaVerifier = null;
      }

      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        "recaptcha-container",
        { size: "invisible" },
      );
      await window.recaptchaVerifier.render();

      const confirmationResult = await firebase
        .auth()
        .signInWithPhoneNumber(phoneNumber, window.recaptchaVerifier);

      onComplete(confirmationResult);
    } catch (error) {
      // Surface the error so the UI can display it and Sentry doesn't
      // capture it as an unhandled rejection
      toast.warning(error.message);
      onError(error);
    }
  };
export const updateInfo =
  (uid, obj, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      await firebase.firestore().collection("users").doc(uid).update({
        state: obj.state,
        city: obj.city,
        school: obj.school,
      });
      const doc = await firebase.firestore().collection("users").doc(uid).get();
      if (doc.exists) {
        dispatch({
          type: "LOGIN_SUCCESS",
          user: { id: doc.id, a4bEmail: doc.data().a4bEmail, ...doc.data() },
          error: "",
        });
        onSuccess();
      } else {
        toast.error("User document does not exist.");
      }
    } catch (error) {
      toast.error("Error updating profile");
    }
  };
export const pizzaMoneyEmail =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    await firebase
      .firestore()
      .collection("users")
      .doc(data.id)
      .update({
        pizzaMoneyEmail: data.pizzaMoneyEmail,
      })
      .then((doc) => {
        dispatch({
          type: "PIZZA_MONEY_EMAIL",
          payload: data.pizzaMoneyEmail,
        });
        onComplete();
        toast.success("Profile Updated Successfully");
      });
  };

export const freeFanCrypto =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      await firebase
        .firestore()
        .collection("users")
        .doc(data.id)
        .update({
          fanOpt: data.fanOpt,
        })
        .then(() => {
          dispatch({
            type: "FAN_CRYPTO",
            payload: data.fanOpt, // Dispatch `fanOpt` value
          });
          onComplete();
          toast.success("Updated Successfully");
        });
    } catch (err) {
      toast.error(err.message);
    }
  };

export const freeManagerCrypto =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      await firebase
        .firestore()
        .collection("users")
        .doc(data.id)
        .update({
          managerOptIn: data.managerOptIn,
        })
        .then(() => {
          dispatch({
            type: "MANAGER_CRYPTO",
            payload: data.managerOptIn,
          });
          onComplete();
          toast.success("Updated Successfully");
        });
    } catch (err) {
      toast.error(err.message);
    }
  };

export const updateAdsShow =
  (uid, obj, onSuccess = () => {}) =>
  async (dispatch) => {
    await firebase.firestore().collection("users").doc(uid).update({
      showAds: obj,
    });
    const doc = await firebase.firestore().collection("users").doc(uid).get();
    if (doc.exists) {
      dispatch({
        type: "LOGIN_SUCCESS",
        user: { id: doc.id, a4bEmail: doc.data().a4bEmail, ...doc.data() },
        error: "",
      });
    }
    toast.success("Update Ads Show Successfully");
    onSuccess();
  };

export const updateCryptoWallet =
  (uid, walletAddress, onSuccess = () => {}) =>
  async (dispatch) => {
    await firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ walletAddress });
    const doc = await firebase.firestore().collection("users").doc(uid).get();
    if (doc.exists) {
      dispatch({
        type: "LOGIN_SUCCESS",
        user: { id: doc.id, a4bEmail: doc.data().a4bEmail, ...doc.data() },
        error: "",
      });
    }
    toast.success("Update Wallet Address Successfully");
    onSuccess();
  };

export const updateManagerData =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    let { oldImage, id, photo, ...newData } = data;

    const refreshUser = async () => {
      const doc = await firebase.firestore().collection("users").doc(id).get();
      if (doc.exists) {
        dispatch({
          type: "LOGIN_SUCCESS",
          user: { id: doc.id, ...doc.data() },
          error: "",
        });
      }
      toast.success("Manager data updated Successfully");
      onComplete();
    };

    try {
      if (photo && photo.name) {
        if (oldImage && !oldImage.name) {
          try {
            await firebase.storage().refFromURL(oldImage).delete();
          } catch (_) {}
        }
        const storageRef = firebase.storage().ref();
        const imageRef = storageRef.child(`users/${id}/manager_photo`);
        const snapshot = await imageRef.put(photo);
        const url = await snapshot.ref.getDownloadURL();
        await firebase
          .firestore()
          .collection("users")
          .doc(id)
          .update({ ...newData, photo: url });
      } else {
        await firebase
          .firestore()
          .collection("users")
          .doc(id)
          .update({ ...newData, photo: photo || "" });
      }
      await refreshUser();
    } catch (error) {
      toast.error("Error updating manager data");
    }
  };
export const updateManagerPhone =
  (id, phoneNumber, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const updatedData = { phoneNumber };
      await firebase
        .firestore()
        .collection("users")
        .doc(id)
        .update(updatedData);
      const doc = await firebase.firestore().collection("users").doc(id).get();
      if (doc.exists) {
        const updatedDocData = { id: doc.id, ...doc.data() };
        dispatch({
          type: "LOGIN_SUCCESS",
          user: updatedDocData,
          error: "",
        });
        onComplete();
        toast.success("Phone number updated successfully");
      } else {
        toast.error("Document not found");
      }
    } catch (error) {
      toast.error("Error updating phone number");
    }
  };

export const switchLayout = (cond) => (dispatch) => {
  dispatch({
    type: "SWITCH_LAYOUT",
    payload: cond,
  });
};
